import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import QRCode from 'qrcode.react';
import { renderToStaticMarkup } from 'react-dom/server';

import { Url } from '../../shared/Url';
import Post from '../../shared/Post';
import Preloader from  "../../views/Preloader/Preloader";

import logo from "../../assets/img/logo_menu_black.png";

import ReciboDePagoUrl from '../../components/Reportes/ReciboDePagoUrl';
import { SvgToPng } from "../../funciones/AdmisionFunction";


let status = 1
class VerifyRecibo extends Component {
    state = {
        datos: "",
        qr: "",
        logo: "",
    }

    constructor (props) {
        super (props)
        this.consultarToken()
        this. convertImgToBase64(logo, (base64Img) => {
            this.setState({
                logo: base64Img
            })
        });
    }

    consultarToken = () => {
        let Content = this.getGET();
        Post(`${Url}verifyRecibo`, Content, (resp) => {
            let data = JSON.parse(resp)
            status = parseInt(data.status)
            let dataQ = "";

            if (data.datos !== undefined) dataQ = data.datos[0];
            
            this.setState({
                datos: dataQ
            })

            let token = data.datos[0].token;

            let imgSvg = (
                <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/recibo?code=${token.substring(0,10)}`}/>
            )
            
            const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
            const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
    
            SvgToPng (dataUri, (qr) => {
                this.setState({
                    qr: qr,
                })
            })            
        });
    }

    contenido = () => {
        switch (status) {
            case 1:
                return(<Preloader/>) 
            case 2:
                let { datos, qr, logo } = this.state;
                return (
                    <ReciboDePagoUrl
                        datos = {datos}
                        qrCode = {qr}
                        logo = {logo}
                    />
                );
            case 3:
                return (<Redirect to = "/home" />);
            default: return null;
        }
    }


    getGET = () => {
        let loc = document.location.href;
        if(loc.indexOf('?') > 0){
            let getString = loc.split('?')[1];
            let GET = getString.split('&');
            let get = {};
            for(let i = 0, l = GET.length; i < l; i++){
                let tmp = GET[i].split('=');
                get[tmp[0]] = unescape(decodeURI(tmp[1]));
            }
            return get;
        }
    }
 
    convertImgToBase64 = (url, callback, outputFormat) => {
        let canvas = document.createElement('CANVAS'),
            ctx = canvas.getContext('2d'),
            img = new Image; img.crossOrigin = 'Anonymous';
        img.onload = () => {
            let dataURL;
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            dataURL = canvas.toDataURL(outputFormat);
            callback.call(this, dataURL);
            canvas = null;
        };
        img.src = url;
    }

    render() {
        return (
            this.contenido()
        );
    }
}
 
export default VerifyRecibo;


// WEBPACK FOOTER //
// ./src/site/Views/VerifyRecibo.jsx